<script setup lang="ts">
const props = defineProps<{
  name: string,
}>()

const { inputMode, game, addOfferNumber } = useBoard(props.name)

const dialog = ref(inputMode.value === 'offer_number')
const offerNumber = ref(1)

watch(inputMode, (value) => {
  if (value === 'offer_number') {
    dialog.value = true
  } else if (dialog.value === true) {
    dialog.value = false
  }
})

const computedOfferNumberPropsList = computed(() => {
  const upperOfferNumber = getOpeningRuleController(game.value.openingRule).upperOfferNumber
  return Array(upperOfferNumber).fill(0).map((_, i) => {
    return {
      label: `${i + 1}題`,
      value: i + 1
    }
  })
})

const handleClickOK = () => {
  addOfferNumber(offerNumber.value)
  dialog.value = false
}
</script>

<template>
  <v-snackbar
    v-model="dialog"
    :attach="`#${props.name}`"
    absolute
    :timeout="-1"
    :offset="-100"
  >
    <span class="text-caption">
      題数提示
    </span>
    <template #actions>
      <v-select
        v-model="offerNumber"
        variant="outlined"
        hide-details
        density="compact"
        dirty
        :items="computedOfferNumberPropsList"
        item-value="value"
        item-title="label"
      />
      <v-btn
        class="ml-4"
        variant="outlined"
        size="small"
        @click="handleClickOK"
      >
        OK
      </v-btn>
    </template>
  </v-snackbar>
</template>
